import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "../../common";
const SYMBOL_SHOW = "symbol/show";

export const showSymbol = createAsyncThunk(SYMBOL_SHOW, async (thunkAPI) => {
  try {
    const { data } = await axios.get("Symbol", {
      params: {
        $filter: "(IsActive eq true) and (IsAppliedOnEcap eq true)",
      },
      headers: {
        MappedState: 1,
      },
    });
    return data.value;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});
